exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".slider-image-container {\r\n    width: 100%;\r\n    height: 465px;\r\n    overflow: hidden;\r\n}\r\n\r\n.container {\r\n    max-width: 1900px;\r\n    width: 100%;\r\n    padding: 0;\r\n}\r\n\r\n.view2 {\r\n    margin-top: -465px;\r\n}\r\n\r\n.view3 {\r\n    margin-top: -465px;\r\n}\r\n\r\ndiv.slider-wrapper {\r\n    background-color: white;\r\n    width: 100%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/img-slider/img-slider.component.css
// module id = 755
// module chunks = 1